
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/__c__",
      function () {
        return require("private-next-pages/__c__/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/__c__"])
      });
    }
  